import classes from "./Button.module.scss";
import { useGameSounds } from "@educaplay/core/hooks";
import {NAME_SOUND_ACTIVE } from "@educaplay/core/utils";
import clsx from "clsx";
import PropTypes from "prop-types";

export default function Button(props) {
    const { Icon, onClick, label, className, disabled, variant = "default", size = "medium"} = props;

    const gameSounds = useGameSounds();
    const buttonClasses = clsx(
            classes.button,
            className,
            variant === 'primary' && classes.primary,
            size === 'large' && classes.large,
        );

    return (
        <button
            type='button'
            disabled={disabled}
            className={buttonClasses}
            onClick={onClick}
            onMouseEnter={() => gameSounds.play(NAME_SOUND_ACTIVE)}
        >
            <Icon  />

            <span className={classes.label}>{label}</span>
        </button>
    )
}

Button.propTypes = {
    Icon: PropTypes.elementType.isRequired,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    variant: PropTypes.oneOf(['primary', 'default']),
    size: PropTypes.oneOf(['medium', 'large']),
}